import { nsurlsession } from "./nsurlsession/client.mjs";
export const objc = {
    info: {
        key: 'objc',
        title: 'Objective-C',
        extname: '.m',
        default: 'nsurlsession',
    },
    clientsById: {
        nsurlsession,
    },
};
